import { captureException } from './sentry';
import { NewOrder_PunchoutOrderMessageFieldsFragment } from '@/types';

const PUNCHOUT_API_METHOD = 'POST';

export const postPunchoutOrderMessage = (
  punchoutOrderMessage: NewOrder_PunchoutOrderMessageFieldsFragment,
) => {
  // Punchout only works on web
  if (typeof window === 'undefined') {
    return;
  }

  try {
    const formElement = document.createElement('form');
    formElement.setAttribute('action', punchoutOrderMessage.order_message_url);
    formElement.setAttribute('method', PUNCHOUT_API_METHOD);

    const cXMLInputElement = document.createElement('input');
    cXMLInputElement.setAttribute('type', 'hidden');
    cXMLInputElement.setAttribute('name', 'cxml-urlencoded');
    cXMLInputElement.setAttribute(
      'value',
      punchoutOrderMessage.order_message_xml,
    );
    formElement.appendChild(cXMLInputElement);

    document.body.appendChild(formElement);
    formElement.submit();
  } catch (e) {
    captureException(e);
  }
};
